/**
 * GraphQL Query that fetches the related products of a product
 */
export default `
  query relatedProduct(
    $search: String = ""
    $filter: ProductAttributeFilterInput
    $pageSize: Int = 10
    $currentPage: Int = 1
    $sort: ProductAttributeSortInput
  ) {
    products(search: $search, filter: $filter, sort: $sort, pageSize: $pageSize, currentPage: $currentPage) {
      items {
        related_products {
          pid: id
          sku
          name
          stock_status
          date_online # --- ADDED ---
          product_label # --- ADDED ---
          # only_x_left_in_stock
          # rating_summary
          thumbnail {
            url
            #  position
            #  disabled
            #  label
          }
          thumbnail_hover # --- ADDED ---
          # url_key
          url_rewrites {
            url
          }
          price_range {
            maximum_price {
              final_price {
                value
              }
            }
            minimum_price {
              final_price {
                value
              }
              regular_price {
                value
              }
            }
          }
          review_count
          rating_summary
          # --- ADDED ---
          colour_wheels {
            name
            image
            # url
          }
          ... on ConfigurableProduct {
            variants {
              attributes {
                # uid
                label
                # code
              }
              product {
                stock_status
                thumbnail {
                  #   label
                  url
                }
              }
            }
            configurable_options {
              attribute_code
              # attribute_uid
              label
              # uid
              values {
                # label
                # uid
                swatch_data {
                  value
                }
              }
            }
          }
          __typename
        }
      }
    }
  }
`
